/**
 *
 */
var AlignmentMode = /** @class */ (function () {
    function AlignmentMode() {
    }
    /**
     *
     */
    AlignmentMode.REGISTRATION_POINT = 'registrationPoint';
    /**
     *
     */
    AlignmentMode.TRANSFORM_POINT = 'transformPoint';
    return AlignmentMode;
}());
export { AlignmentMode };
